import { render } from "./RegisterItensForm.vue?vue&type=template&id=20f6c46c&scoped=true"
import script from "./RegisterItensForm.vue?vue&type=script&lang=js"
export * from "./RegisterItensForm.vue?vue&type=script&lang=js"

import "./RegisterItensForm.vue?vue&type=style&index=0&id=20f6c46c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f6c46c"]])

export default __exports__